module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _c('h1', {
    staticClass: "pre_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("A Testament of Listening")])]), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("“Faith comes from hearing, and hearing through the word of Christ.”")])]), _c('div', {
    staticClass: "exer_source"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMANS 10:17")]), _vm._v(" ESV")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-002"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/ch_ding_gray.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("N")]), _vm._v("ot long ago I took our daughter Debbie and two of our grown grandchildren on a memory trip to places in Canada where I grew up.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One special spot we visited was on Lake Rosseau in the Muskoka lakes region. It was once the site of a Bible conference, long since defunct, where my mother took me many summers of my early life.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As we cruised by boat along the rocky shore, I could see the old buildings derelict and deserted, but the memories stayed with me. I recalled the children’s meetings where a retired missionary woman and a college student told us about Jesus, and how at the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("end of that week I put up my hand to say I wanted to know and follow him.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The leaders said I was too young. But after I lifted my hand three times they realized I knew what I wanted, at least as much as a child could take in.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I was five then. Now, eighty plus years later, I can barely recall the voices and faces of that missionary lady and that college student, but I know that through them I heard another Voice calling me, a voice I have been listening for ever since. So I write my listening story not because it is a perfect story or one to emulate but as a testament to the power of listening for the voice of my Lord.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Did I always listen to what the poet Mary Oliver called his “incomparably lovely young-man voice”? No, not always. Often I have been too busy, too preoccupied with my own thoughts, too intent on having my own way or waywardness. Yet often, when I have truly listened, that other Voice has spoken quietly but insistently.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Did I sometimes mistake my own voice for that Other? No doubt, but when I have stopped to pay attention I have recognized, through and beyond my own and other voices, the Voice of One who speaks with accents of truth, love, beauty, and grace.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I truly believe—from the Holy Scriptures and my own experience—that out of the many voices that speak to us, voices of blessing or otherwise, as we discern the Voice of the Great Shepherd, we find our own deepest identity.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As that splendid poet Gerard Manley Hopkins wrote, each mortal thing cries, “What I do is me, for that I came.” Then in a magnificent image he writes that “Christ plays in ten thousand "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("places, lovely in limbs and lovely in eyes not his, to the Father, through the features of men’s faces.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Hopkins’s words resonate with the biblical promise that we can be changed, transformed. They are also in sync with neuroscientists who study the brain, who are telling us that our brains are not totally hardwired, that they can be rewired.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So I truly believe, as we listen deeply and faithfully to Christ the Living Word, as his words in Scripture and his Spirit indwell our brains and imaginations, we may discern "), _c('i', [_vm._v("his")]), _vm._v(" voice through "), _c('i', [_vm._v("ten thousand voices")]), _vm._v(", and heeding, become the persons we were created to be and long to be.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I hope you may find my story interesting and encouraging. But more than that, I pray it will be to you an invitation not just to listen on occasion but to "), _c('i', [_vm._v("be a listener")]), _vm._v(", one who pays attention to the God who speaks.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0